import { Injectable } from '@angular/core';
import { HttpService } from '../../../../core/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@base/environments/environment';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DownloadCatchmentsListService extends HttpService {

  constructor(public override http: HttpClient) {
    super(http);
    this.url = '/descargas/excel/listado/captaciones/reservas';
    this.baseUrl = environment.apiEndpoint;
  }
  
  async downloadList(payload: any): Promise<any> {
    try {
      const DATA = await firstValueFrom(
        this.downloadListObservable(payload)
      );
      return JSON.parse(JSON.stringify(DATA));
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  
  downloadListObservable(payload: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

    return this.http.post(
      `${this.baseUrl}${this.url}`,
      payload,
      { headers }
    );
  }
}
